import React from 'react';
import { FaChartBar, FaCarSide, FaMoneyBillWave } from 'react-icons/fa';

const D2Reports = () => {
  return (
    <div className="p-8 h-full w-full bg-slate-50/50 flex flex-col overflow-y-auto animate-fade-in-up">
      {/* Title Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
        <div>
          <h1 className="text-3xl font-extrabold text-slate-800 tracking-tight flex items-center gap-3">
            <span className="p-2.5 bg-blue-50 text-blue-600 rounded-2xl shadow-sm border border-blue-100">
              <FaChartBar size={24} />
            </span>
            Reports Overview
          </h1>
          <p className="text-slate-500 text-xs mt-1 leading-relaxed">
            Monitor finance penetration rates, gross margins, vehicle sales volume, and lender metrics.
          </p>
        </div>
      </div>

      {/* Metrics Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {/* Metric 1 */}
        <div className="bg-white p-6 rounded-2xl border border-slate-200/60 shadow-sm flex items-center justify-between hover:shadow-md transition-all duration-300">
          <div className="flex items-center">
            <div className="p-4 rounded-xl bg-indigo-50 text-indigo-600 mr-4 shadow-sm">
              <FaChartBar size={22} />
            </div>
            <div>
              <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">Deals Processed</p>
              <p className="text-2xl font-extrabold text-slate-800 mt-1">0</p>
            </div>
          </div>
          <span className="text-xs font-semibold px-2 py-1 bg-slate-50 text-slate-400 rounded-lg">This Month</span>
        </div>

        {/* Metric 2 */}
        <div className="bg-white p-6 rounded-2xl border border-slate-200/60 shadow-sm flex items-center justify-between hover:shadow-md transition-all duration-300">
          <div className="flex items-center">
            <div className="p-4 rounded-xl bg-emerald-50 text-emerald-600 mr-4 shadow-sm">
              <FaMoneyBillWave size={22} />
            </div>
            <div>
              <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">Gross Profit</p>
              <p className="text-2xl font-extrabold text-emerald-600 mt-1">$0.00</p>
            </div>
          </div>
          <span className="text-xs font-semibold px-2 py-1 bg-slate-50 text-slate-400 rounded-lg">Realtime</span>
        </div>

        {/* Metric 3 */}
        <div className="bg-white p-6 rounded-2xl border border-slate-200/60 shadow-sm flex items-center justify-between hover:shadow-md transition-all duration-300">
          <div className="flex items-center">
            <div className="p-4 rounded-xl bg-amber-50 text-amber-600 mr-4 shadow-sm">
              <FaCarSide size={22} />
            </div>
            <div>
              <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">Inventory Value</p>
              <p className="text-2xl font-extrabold text-slate-800 mt-1">$0.00</p>
            </div>
          </div>
          <span className="text-xs font-semibold px-2 py-1 bg-slate-50 text-slate-400 rounded-lg">Asset Vol</span>
        </div>
      </div>

      {/* Feature Card placeholder */}
      <div className="bg-white rounded-3xl border border-slate-200/60 p-12 text-center flex flex-col items-center justify-center flex-1 shadow-sm relative overflow-hidden">
        {/* Background glow bubble */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-indigo-50/40 rounded-full blur-3xl -z-10"></div>
        
        <div className="p-5 rounded-2xl bg-indigo-50 text-indigo-600 mb-6 shadow-md shadow-indigo-100/50">
          <FaChartBar size={40} />
        </div>
        <h2 className="text-2xl font-bold text-slate-800 mb-2 tracking-tight">Detailed Reporting Coming Soon</h2>
        <p className="text-slate-500 text-sm max-w-md mx-auto leading-relaxed font-normal">
          We are currently aggregating dealership operations data. Once deals start being structured and processed through Dealership 2.0, detailed analytics on sales consultant performance, F&I penetration, and lender capture rates will populate here.
        </p>
      </div>
    </div>
  );
};

export default D2Reports;
